import { render, staticRenderFns } from "./DescriptionMainProductCard.vue?vue&type=template&id=a13dca42&scoped=true&"
import script from "./DescriptionMainProductCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionMainProductCard.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionMainProductCard.vue?vue&type=style&index=0&id=a13dca42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13dca42",
  null
  
)

export default component.exports